import React from 'react'
import { css } from '@emotion/core'
import { getColors } from './utils'

const textCss = css`
  // override some paragraph styles
  --special-type-color: var(--color);
  color: var(--color);
`

const linkCss = css`
  // increase specificity
  & a[href] {
    text-decoration-line: none;

    // override the default link color
    color: var(--color);

    &:hover {
      color: var(--hover-color);
    }
  }
`

/**
 * Makes the text either Black or White based on the Theme. It also removes the default styles (blue, underline, visited) if it's a link.
 *
 * It is supposed to be an evolution of how we used WhiteTheme for headings and can be used in situations that are not linked headings.
 */
export const MonoText = ({ children, complementary }) => {
  const [color, hoverColor] = getColors(complementary)

  return (
    <span css={[textCss, linkCss]} style={{ '--color': color, '--hover-color': hoverColor }}>
      {children}
    </span>
  )
}
